module.exports = __webpack_public_path__ + "static/determined-collapsed-4-9581bce8b4e64e3c677ad026dc2b4d74.png";